export const CREATE_REQUEST_MESSAGE = {
  id: 'CREATE_REQUEST',
  defaultMessage: 'Create Request',
};

export const CREATE_ISSUE_ACTION_MESSAGE = {
  id: 'CREATE',
  defaultMessage: 'Create',
};
